import React from 'react';
import Events1 from './1';
import Events2 from './2';
import Events3 from './3';
import Events4 from './4';
import Events5 from './5';
import Events6 from './6';

function Events() {
  return (
    <>
      <Events1 />
      <Events2 />
      <Events3 />
      <Events4 />
      <Events5 />
      {/* <Events6 /> */}
    </>
  );
}

export default Events;
